import React, { useCallback, useRef } from "react";
import cx from "classnames";
import { useForm } from "../../hooks/useForm";
import { useValidation } from "../../hooks/useValidation";
import { InputErrorList } from "../input/InputErrorList";
import { InputIcon } from "../input/InputIcon";
import "../input/Input.scss";
import "./Select.scss";
export function Select({ alternatives, value, placeholder, label, disabled, onChange, validators = [], forceValidation = false, name, autoComplete, "data-test-id": dataTestId, }) {
    const selectId = useRef("select_" + Math.random().toString(36).substr(2, 9));
    const containerRef = useRef(null);
    const [validity, errorMessages, validityClasses, resetValidation,] = useValidation(value, validators, forceValidation);
    useForm(selectId.current, validity, value, resetValidation, containerRef, errorMessages, label);
    const innerOnChange = useCallback((event) => {
        const alternative = alternatives.find((alternative) => {
            return event.target.value === alternative.value.toString();
        });
        alternative && onChange && onChange(alternative);
    }, [onChange, alternatives]);
    const classes = cx("lysa-ui-select", validityClasses, { disabled });
    return (React.createElement("div", { ref: containerRef, className: "lysa-ui-input-group" },
        React.createElement("label", { htmlFor: selectId.current }, label),
        React.createElement("div", { className: classes },
            React.createElement("select", { id: selectId.current, value: value && value.value ? value.value.toString() : "", name: name || selectId.current, autoComplete: autoComplete, disabled: disabled, onChange: innerOnChange, "data-test-id": dataTestId },
                placeholder ? (React.createElement("option", { value: "", disabled: true }, placeholder)) : null,
                alternatives.map((alternative) => (React.createElement("option", { key: `${alternative.text}-${alternative.value}`, value: (alternative.value || "").toString(), disabled: alternative && alternative.disabled }, alternative.text)))),
            React.createElement(InputIcon, null),
            React.createElement(InputErrorList, { errorMessages: errorMessages }))));
}
